import { useCallback } from 'react';
import PropTypes from 'prop-types';

const FigmaAnnotatorMenu = ({ getComponent }) => {
  const DropdownMenu = getComponent('DropdownMenu');
  const DropdownMenuItem = getComponent('DropdownMenuItem');

  const handleFigmaAnnotatorClick = useCallback((event) => {
    event.preventDefault();
    window.location.href = '/figma-annotator';
  }, []);

  const handleFigmaAnnotatorPocClick = useCallback((event) => {
    event.preventDefault();
    window.location.href = '/figma-annotator-poc';
  }, []);

  return (
    <DropdownMenu label="Figma">
      <DropdownMenuItem onClick={handleFigmaAnnotatorClick}>
        Figma Annotator
      </DropdownMenuItem>
      <DropdownMenuItem onClick={handleFigmaAnnotatorPocClick}>
        Figma Annotator (POC)
      </DropdownMenuItem>
    </DropdownMenu>
  );
};

FigmaAnnotatorMenu.propTypes = {
  getComponent: PropTypes.func.isRequired,
};

export default FigmaAnnotatorMenu;
